import { apiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BaseResource";
class LimitCustomerResource extends BaseCamelCasedResource {
    pk() {
        return this.limitCustomerId?.toString() || "";
    }
    /**
     * Get the url for many Resources
     */
    static listUrl(allParams = {}) {
        const { applicationId } = allParams;
        if (applicationId !== undefined) {
            return `${this.urlRoot}/get-limit-customers-for-app/${applicationId}`;
        }
        throw new Error("LimitCustomerResource require applicationId");
    }
}
LimitCustomerResource.urlRoot = apiResourceUrl("limit-customer");
export { LimitCustomerResource };
//# sourceMappingURL=LimitCustomerResource.js.map